import React, { useEffect, useState, useRef } from "react";
import Videojs from "../../video-js";
import Image from "../../../elements/image";
import classNames from "classnames";
import { mobileIs } from "../../../utils/siteUtils";
const GraphicCombinationMedia = (props) => {
  const { data, index, activeIndex, oldActiveIndex } = props;
  let { video, image, autoPlay } = data.fields;
  const videoEl = useRef();
  let timer = null;
  const isMobile = mobileIs();
  const [showControl, setShowControl] = useState(false);
  const [videoLoad, setVideoLoad] = useState(false);
  const videoOptions =
    video && video.value
      ? {
          sources: [
            {
              src: video.value.src,
              type: video.value.mimeType
            }
          ],
          poster: image.value.src,
          videoTitle: '',
          autoplay: autoPlay.value,
          controls: true,
          muted: true,
					loop: true
        }
      : {};
	  useEffect(() => {
		if(video && !video.value) return
		if(videoLoad){
			videoLoadPlay()
		}else{
			timer = setInterval( _ => {
				if(videoLoad){
					clearInterval(timer)
					videoLoadPlay()
				}
			},100)
		}
	  })

	const videoLoadPlay = _ => {
		if(index === activeIndex){
			if(autoPlay.value && oldActiveIndex!=activeIndex ){
				setTimeout(v=>{
					if(videoEl.current){
						videoPlayStart()
						videoEl.current.player.play(0)
						setTimeout(v=>{
							setShowControl(true)
						})
					}
				},400)
			}else{
				setShowControl(true)
			}
		}else{

			setShowControl(false)
			videoEl.current.player.pause()
			videoEl.current.player.currentTime(0)
			videoEl.current.player.trigger('loadstart')
			setTimeout(v=>{
				if(document.getElementById('video'+index)){
					document.getElementById('video'+index).classList.remove("vjs-has-started")
				}
			},400)
		}
	}
	const videoLoaded = () => {
		setVideoLoad(true)
	}
	const videoPlayStart = () => {
		if(document.getElementById('video'+index)){
			document.getElementById('video'+index).classList.add("vjs-has-started")
		}
	}
	return (
		<div className={classNames("media",showControl? null : 'hideControl')}>
			{ video && !video.value && 
				<Image className="img" { ...image.value} />
			}
			{ video && video.value && 
				<Videojs ref={videoEl} className="GraphicCombination-video" id={'video'+index} videoLoaded={videoLoaded} videoPlayPressed={videoPlayStart} {...videoOptions}/>
			}
		</div>
	);
};
export default GraphicCombinationMedia;
